import { Flame } from 'lucide-react';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '../ui/tooltip';

export const LoginStreakBadge = ({ streak, bestStreak }) => {
  if (!streak || streak < 1) return null;

  const intensity = Math.min(streak, 7);
  const bgClass = intensity >= 7
    ? 'bg-gradient-to-r from-orange-500 to-red-500 text-white'
    : intensity >= 3
      ? 'bg-orange-100 text-orange-700 dark:bg-orange-900/50 dark:text-orange-300'
      : 'bg-amber-50 text-amber-600 dark:bg-amber-900/40 dark:text-amber-400';

  return (
    <TooltipProvider delayDuration={200}>
      <Tooltip>
        <TooltipTrigger asChild>
          <div
            className={`flex items-center gap-1 px-2 py-1 rounded-full text-xs font-semibold cursor-default select-none transition-transform hover:scale-105 ${bgClass}`}
            data-testid="login-streak-badge"
          >
            <Flame className="w-3.5 h-3.5" />
            <span>{streak}</span>
          </div>
        </TooltipTrigger>
        <TooltipContent side="bottom" className="text-center">
          <p className="font-semibold">{streak}-day login streak</p>
          {bestStreak > streak && (
            <p className="text-xs text-muted-foreground">Best: {bestStreak} days</p>
          )}
          {bestStreak <= streak && streak > 1 && (
            <p className="text-xs text-muted-foreground">Personal best!</p>
          )}
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};
